// src/components/home/Header/Header.jsx
import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { HiMenuAlt2 } from "react-icons/hi";
import { motion } from "framer-motion";
import Image from "../../designLayouts/Image";
import Flex from "../../designLayouts/Flex";

// Updated Logo
import logo from "../../../assets/logo.PNG";

// Navigation items for BigMart
const navBarList = [
  { _id: 1, title: "Home", link: "/" },
  { _id: 2, title: "Products", link: "/shop" },
  { _id: 3, title: "About Us", link: "/about" },
  { _id: 4, title: "category", link: "/journal" },
  // { _id: 5, title: "Journal", link: "/Contact" },
  { _id: 6, title: "Contact", link: "/contact-page" },
];

const Header = () => {
  const [showMenu, setShowMenu] = useState(true);
  const [sidenav, setSidenav] = useState(false);
  const [category, setCategory] = useState(false);
  const [brand, setBrand] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setShowMenu(window.innerWidth >= 667);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="w-full sticky top-0 z-50">
      
      {/* Top Blue Bar */}
      <div className="w-full bg-blue-600 text-white text-sm py-2 px-4 flex justify-between items-center">
        <span className="font-light italic">Feel the right shopping experience</span>
        <span className="flex items-center gap-2 font-semibold">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M2.003 5.884l3.89.636a1 1 0 0 1 .764.515l1.734 2.94a1 1 0 0 1-.217 1.25l-2.012 1.758a16.015 16.015 0 0 0 6.036 6.036l1.758-2.012a1 1 0 0 1 1.25-.217l2.94 1.734a1 1 0 0 1 .515.764l.636 3.89A1 1 0 0 1 18.49 23h-1.004C8.503 23 1 15.497 1 6.514V5.5a1 1 0 0 1 1.003-.616z" />
          </svg>
          +971 54 266 0433
        </span>
      </div>

      {/* Main Navigation */}
      <div className="w-full h-20 bg-white border-b border-gray-200 shadow-sm">
        <nav className="h-full px-4 max-w-container mx-auto relative">
          <Flex className="flex items-center justify-between h-full">

            {/* Logo */}
            <Link to="/">
              <Image className="w-24 object-contain" imgSrc={logo} />
            </Link>

            {/* Desktop Menu */}
            {showMenu && (
              <motion.ul
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="flex items-center gap-6"
              >
                {navBarList.map(({ _id, title, link }) => (
                  <NavLink
                    key={_id}
                    to={link}
                    state={{ data: location.pathname.split("/")[1] }}
                    className={({ isActive }) =>
                      `text-gray-700 hover:text-black font-medium px-3 py-2 rounded ${
                        isActive ? "underline decoration-2 underline-offset-4" : ""
                      }`
                    }
                  >
                    {title}
                  </NavLink>
                ))}
              </motion.ul>
            )}

            {/* Mobile Menu Icon */}
            <HiMenuAlt2
              onClick={() => setSidenav(!sidenav)}
              className="md:hidden cursor-pointer w-8 h-8"
            />

            {/* Mobile SideNav */}
            {sidenav && (
              <div className="fixed top-0 left-0 w-full h-screen bg-black bg-opacity-70 z-50">
                <motion.div
                  initial={{ x: -300, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.5 }}
                  className="w-[80%] h-full relative bg-black text-white p-6"
                >
                  {/* Logo */}
                  <Image className="w-28 mb-6" imgSrc={logo} />

                  {/* Navigation */}
                  <ul className="flex flex-col gap-4 text-lg">
                    {navBarList.map((item) => (
                      <li key={item._id}>
                        <NavLink
                          to={item.link}
                          onClick={() => setSidenav(false)}
                          className="hover:underline"
                        >
                          {item.title}
                        </NavLink>
                      </li>
                    ))}
                  </ul>

                  {/* Categories */}
                  <div className="mt-6">
                    <h2
                      onClick={() => setCategory(!category)}
                      className="flex justify-between cursor-pointer font-semibold"
                    >
                      Shop by Category
                      <span>{category ? "-" : "+"}</span>
                    </h2>

                    {category && (
                      <motion.ul
                        initial={{ y: 10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        className="mt-2 text-sm flex flex-col gap-2"
                      >
                        <li>Electronics</li>
                        <li>Home Appliances</li>
                        <li>Grocery</li>
                        <li>Stationery</li>
                        <li>Miscellaneous</li>
                      </motion.ul>
                    )}
                  </div>

                  {/* Brands */}
                  <div className="mt-4">
                    <h2
                      onClick={() => setBrand(!brand)}
                      className="flex justify-between cursor-pointer font-semibold"
                    >
                      Shop by Brand
                      <span>{brand ? "-" : "+"}</span>
                    </h2>

                    {brand && (
                      <motion.ul
                        initial={{ y: 10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        className="mt-2 text-sm flex flex-col gap-2"
                      >
                        <li>Samsung</li>
                        <li>LG</li>
                        <li>Apple</li>
                        <li>Philips</li>
                        <li>Panasonic</li>
                      </motion.ul>
                    )}
                  </div>

                  {/* Close Button */}
                  <span
                    onClick={() => setSidenav(false)}
                    className="absolute top-4 -right-10 w-8 h-8 flex items-center justify-center border text-2xl cursor-pointer hover:text-red-500"
                  >
                    <MdClose />
                  </span>
                </motion.div>
              </div>
            )}
          </Flex>
        </nav>
      </div>
    </div>
  );
};

export default Header;
